import React, { Component } from 'react';
import Helmet from 'react-helmet';

import LoginContainer from '../../../containers/Auth/Login';

class Login extends Component {
  render() {
    return (
      <React.Fragment>
         <Helmet
            titleTemplate="%s - Xelacore PLM Backoffice"
          >
          <title>Login</title>
            <meta name="description" content="Xelacore PLM Backoffice" />
          </Helmet>
          <LoginContainer />
      </React.Fragment>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js